import type {
  ElectionFlow,
  RequiredSubInfo,
  RequiredSubInfoPresenter,
  Subscriber,
  SubscriberPresenter,
} from 'types/electionService';

/**
 * Maps a full `Subscriber` to the subset used by the SubscriberCard.
 * Keeps card logic decoupled from unrelated API and workflow fields.
 */
export function createSubscriberPresenter(subscriber: Subscriber): SubscriberPresenter {
  const { id, common, choice, employeeClass, productLineToCarrier, custom, interestedProductLines } = subscriber;
  return {
    id,
    common,
    choice,
    employeeClass,
    productLineToCarrier,
    custom,
    interestedProductLines,
  };
}

export function createRequiredSubInfoPresenter(
  info: RequiredSubInfo | null | undefined,
  flow: ElectionFlow,
): RequiredSubInfoPresenter | null {
  if (!info) {
    return null;
  }
  if (flow === 'enrollment') {
    return {
      productLineRequiredInfo: info.productLineRequiredInfo,
      dependentsFormId: info.manageDependentFormId,
      subscriberFormId: info.editSubFormId,
      subscriberRequiredFields: info.requiredFields,
    };
  }
  return {
    productLineRequiredInfo: info.productLineRequiredInfo,
    dependentsFormId: info.manageDependentFormId,
    subscriberFormId: info.quotingSubFormId,
    subscriberRequiredFields: info.quotingRequiredFields,
  };
}
